import { Navigate, Outlet, useNavigate } from "react-router-dom";
import { getUserDataFromLocalStorage } from "../../core/services/localStorage/localStorage.service";
import setupInterceptors from "../../core/services/interceptors/interceptors.service";

const ProtectedRoute = () => {
  const navigate = useNavigate();
  const userData = getUserDataFromLocalStorage();

  setupInterceptors(userData, navigate);

  return <Outlet />;

  // return <Navigate to={process.env.REACT_APP_BASE_URL!} />;
};

export default ProtectedRoute;
